import React from 'react';

const HebeMascot: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <svg
      viewBox="0 0 512 512"
      className={`${className} group`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        {/* Rounded rectangle background with hover effect */}
        <rect 
          width="512" 
          height="512" 
          rx="128" 
          className="fill-background group-hover:fill-foreground/5 transition-all duration-300"
        />
        
        {/* Letter H with hover effect */}
        <g className="fill-foreground transition-all duration-300">
          <rect 
            x="144" 
            y="128" 
            width="64" 
            height="256"
            className="group-hover:translate-x-[-4px] transition-transform duration-300" 
          />
          <rect 
            x="304" 
            y="128" 
            width="64" 
            height="256"
            className="group-hover:translate-x-[4px] transition-transform duration-300" 
          />
          <rect 
            x="144" 
            y="240" 
            width="224" 
            height="32"
            className="opacity-animation group-hover:opacity-60 transition-opacity duration-300" 
          />
        </g>
      </g>
    </svg>
  );
};

export default HebeMascot;
